var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"overLay mack"},[_c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":_vm.iconLoading,"alt":""}}),_c('p',[_vm._v("加载中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }